module.exports = __webpack_public_path__ + "static/media/income-chosen.28c0ddae.png";